import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { downloadExcel } from '../../lib/exportUtils';

export default function ExportButton({ getData, filename, label = 'Export Excel' }) {
  const [loading, setLoading] = useState(false);

  async function handleExport() {
    setLoading(true);
    try {
      const sheets = await getData();
      downloadExcel(sheets, filename);
    } catch (e) {
      alert('Export failed: ' + e.message);
    }
    setLoading(false);
  }

  return (
    <button className="btn btn-secondary" onClick={handleExport} disabled={loading}>
      <Download size={14} />
      {loading ? 'Exporting...' : label}
    </button>
  );
}
